import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { GenericService } from "../../commons/generic.service";
import { ChamadoDTO } from "../../components/transferobjects/consulta-chamado/chamado";


@Injectable()
export class PadraoService extends GenericService {
    private relativePath = 'api/';
    resultadoChamado: Observable<string>;

    constructor(http: HttpClient) {
        super(http);
    }

    findById(id): Observable<any> {
        return this.getMethod(this.relativePath + id);
    }

    consultarChamado(numeroDoChamado: string, email: string): Observable<ChamadoDTO> {
        const param = new HttpParams().set('email', email);
        return this.http.get<ChamadoDTO>(this.url + this.relativePath + 'chamado/consultar/' + numeroDoChamado, {params: param});
    }

    abrirChamado(formulario: any, anexos: any): Observable<String> {
        const formData: any = new FormData();
        formData.append('chamadoAdvogadoDelegatario', formulario);
        anexos.forEach(anexo => formData.append('anexo', anexo));
        return this.http.post<String>(this.url + this.relativePath + 'chamado/', formData);
    }


    abrirChamadoList(formularios: any, anexos: any): Observable<String> {
        const formData: any = new FormData();
        formularios.forEach(form => formData.append('chamadoAdvogadoDelegatario',JSON.stringify(form)));
        anexos.forEach(anexo => formData.append('anexo', anexo));
        return this.http.post<String>(this.url + this.relativePath + 'chamadoList/', formData);
    }

    abrirChamadoCadastroAcesso(formulario: any, anexos: any): Observable<String> {
        const formData: any = new FormData();
        formData.append('chamadoAdvogadoDelegatario', formulario);
        anexos.forEach(anexo => formData.append('anexo', anexo));
        return this.http.post<String>(this.url + this.relativePath + 'chamadoCadastroAcesso/', formData);
    }


    

    abrirChamadoErrofalhaInfo(formulario: any, anexos: any): Observable<String> {
        const formData: any = new FormData();
        formData.append('chamadoAdvogadoDelegatario', formulario);
        anexos.forEach(anexo => formData.append('anexo', anexo));
        console.log(formData);
        return this.http.post<String>(this.url + this.relativePath + 'chamadoErrofalhaInfo/', formData);
    }
}
